<template>
	<div style="padding-top: 10px;padding-bottom: 50px;">
		<h1 style="font-size: 40px;text-align: center;margin-bottom: 25px;margin-top: 8px;">首页内容设置</h1>
		<el-descriptions title="第一模块圆形图片" :column="2" size="40" border :contentStyle="rowCenter"
			:labelStyle="rowCenter">
			<template slot="extra">
				<el-button type="primary" size="small" @click="eidt(10)">编辑</el-button>
			</template>
			<el-descriptions-item>
				<template slot="label">
					图片
				</template>
				<label v-for="(item,index) in imageList" :key="index" style="margin-left: 10px;">
					<el-image style="width: 90px;height: 30px;" :src="item" @click="setImage(item)"
						:preview-src-list="imageList">
					</el-image>
				</label>
			</el-descriptions-item>

		</el-descriptions>
		<el-descriptions title="第一模块" :column="2" size="40" border :contentStyle="rowCenter" :labelStyle="rowCenter">
			<template slot="extra">
				<el-button type="primary" size="small" @click="eidt(1)">编辑</el-button>
			</template>
			<el-descriptions-item>
				<template slot="label">
					标题(中文)
				</template>
				{{ firstData[0].content }}
			</el-descriptions-item>
			<el-descriptions-item>
				<template slot="label">
					标题(英文)
				</template>
				{{ firstData[0].contentEg }}
			</el-descriptions-item>
			<el-descriptions-item>
				<template slot="label">
					内容(中文)
				</template>
				{{ firstData[1].content }}
			</el-descriptions-item>
			<el-descriptions-item>
				<template slot="label">
					内容(英文)
				</template>
				{{ firstData[1].contentEg }}
			</el-descriptions-item>

			<el-descriptions-item>
				<template slot="label">
					背景图片
				</template>
				<el-image style="width: 50px;height: 50px;" :src="firstData[2].content"
					@click="setImage(firstData[2].content)" :preview-src-list="secondImageUrl">
				</el-image>
			</el-descriptions-item>

		</el-descriptions>

		<el-descriptions title="第二模块及案例列表" style="margin-top: 20px;" :column="2" size="40" border
			:contentStyle="rowCenter" :labelStyle="rowCenter">
			<template slot="extra">
				<el-button type="primary" size="small" @click="eidt(2)">编辑</el-button>
			</template>
			<el-descriptions-item v-for="(item,index) in secondTitle" :key="index">
				<template slot="label">
					{{item.title}}
				</template>
				<el-image v-if="item.contentType == 2" style="width: 50px;height: 50px;" :src="item.content"
					@click="setImage(item.content)" :preview-src-list="secondImageUrl">
				</el-image>
				<span v-else>{{ item.content}} </span>
			</el-descriptions-item>


		</el-descriptions>

		<el-descriptions title="第三模块" style="margin-top: 20px;" :column="2" size="40" border :contentStyle="rowCenter"
			:labelStyle="rowCenter">
			<template slot="extra">
				<el-button type="primary" size="small" @click="eidt(3)" v-show="false">编辑</el-button>
			</template>
			<el-descriptions-item>
				<template slot="label">
					标题(中文)
				</template>
				{{ thirdData[0].content }}
			</el-descriptions-item>
			<el-descriptions-item>
				<template slot="label">
					标题(英文)
				</template>
				{{ thirdData[0].contentEg }}
			</el-descriptions-item>

		</el-descriptions>

		<el-descriptions title="第四模块" style="margin-top: 20px;" :column="2" size="40" border :contentStyle="rowCenter"
			:labelStyle="rowCenter">
			<template slot="extra">
				<el-button type="primary" size="small" @click="eidt(4)">编辑</el-button>
			</template>
			<el-descriptions-item>
				<template slot="label">
					标题(中文)
				</template>
				{{ fourthData[0].content }}
			</el-descriptions-item>
			<el-descriptions-item>
				<template slot="label">
					标题(英文)
				</template>
				{{ fourthData[0].contentEg }}
			</el-descriptions-item>

			<el-descriptions-item>
				<template slot="label">
					标题(中文)
				</template>
				{{ fourthData[1].content }}
			</el-descriptions-item>
			<el-descriptions-item>
				<template slot="label">
					标题(英文)
				</template>
				{{ fourthData[1].contentEg }}
			</el-descriptions-item>


			<el-descriptions-item>
				<template slot="label">
					标题(中文)
				</template>
				{{ fourthData[2].content }}
			</el-descriptions-item>
			<el-descriptions-item>
				<template slot="label">
					标题(英文)
				</template>
				{{ fourthData[2].contentEg }}
			</el-descriptions-item>

		</el-descriptions>

		<el-descriptions title="第五模块" style="margin-top: 20px;" :column="2" size="40" border :contentStyle="rowCenter"
			:labelStyle="rowCenter">
			<template slot="extra">
				<el-button type="primary" size="small" @click="eidt(5)">编辑</el-button>
			</template>
			<el-descriptions-item v-for="(item,index) in fifthTitle" :key="index">
				<template slot="label">
					{{item.title}}
				</template>
				{{ item.content}}
			</el-descriptions-item>

		</el-descriptions>

		<el-descriptions title="第六模块" style="margin-top: 20px;" :column="2" size="40" border :contentStyle="rowCenter"
			:labelStyle="rowCenter">
			<template slot="extra">
				<el-button type="primary" size="small" @click="eidt(6)">编辑</el-button>
			</template>
			<el-descriptions-item v-for="(item,index) in sixthTitle" :key="index">
				<template slot="label">
					{{item.title}}
				</template>
				{{ item.content}}
			</el-descriptions-item>

		</el-descriptions>

		<el-descriptions title="第七模块" style="margin-top: 20px;" :column="2" size="40" border :contentStyle="rowCenter"
			:labelStyle="rowCenter">
			<template slot="extra">
				<el-button type="primary" size="small" @click="eidt(7)">编辑</el-button>
			</template>
			<el-descriptions-item v-for="(item,index) in seventhTitle" :key="index">
				<template slot="label">
					{{item.title}}
				</template>
				{{ item.content}}
			</el-descriptions-item>

		</el-descriptions>

		<el-descriptions title="第八模块" style="margin-top: 20px;" :column="2" size="40" border :contentStyle="rowCenter"
			:labelStyle="rowCenter">
			<template slot="extra">
				<el-button type="primary" size="small" @click="eidt(8)">编辑</el-button>
			</template>
			<el-descriptions-item v-for="(item,index) in eightTitle" :key="index">
				<template slot="label">
					{{item.title}}
				</template>
				{{ item.content}}
			</el-descriptions-item>

		</el-descriptions>

		<el-descriptions title="第九模块" style="margin-top: 20px;" :column="2" size="40" border :contentStyle="rowCenter"
			:labelStyle="rowCenter">
			<template slot="extra">
				<el-button type="primary" size="small" @click="eidt(9)">编辑</el-button>
			</template>
			<el-descriptions-item v-for="(item,index) in ninethTitle" :key="index">
				<template slot="label">
					{{item.title}}
				</template>
				{{ item.content}}
			</el-descriptions-item>

		</el-descriptions>

		<el-dialog title="修改信息" :visible.sync="cirleDialogVisible" width="60%" center>
			<el-form ref="form" :model="cirleform" label-width="80px">

				<el-form-item label="圆形图片(从右下角为第一张,以此类推)" prop="subtitle">
					<el-upload :action="uploadUrl" list-type="picture-card" :on-preview="handlePictureCardPreview22"
						:on-success="handleAvatarSuccess22" :before-upload="beforeAvatarUpload22"
						:file-list="imageList1" :on-remove="handleRemove22">
						<i class="el-icon-plus"></i>
					</el-upload>
					<el-dialog :visible.sync="dialogVisible">
						<img width="100%" :src="dialogImageUrl" alt="">
					</el-dialog>
				</el-form-item>

			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="cirleDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="save(10)">{{ btnText }}</el-button>
			</span>
		</el-dialog>

		<el-dialog title="修改信息" :visible.sync="firstDialogVisible" width="60%" center>
			<el-form ref="form" :model="firstform" label-width="80px">

				<el-form-item label="标题(中文)" prop="title">
					<el-col :span="20" style="border: 1px solid gray;">
						<!-- <el-input v-model="firstform.title"></el-input> -->
						<tinymce-editor v-model="firstform.title" :init="initEditor" />

					</el-col>
				</el-form-item>

				<el-form-item label="标题(英文)" prop="title">
					<el-col :span="20" style="border: 1px solid gray;">
						<!-- <el-input v-model="firstform.title1"></el-input> -->
						<tinymce-editor v-model="firstform.title1" :init="initEditor" />

					</el-col>
				</el-form-item>

				<el-form-item label="内容(中文)" prop="content">
					<el-col :span="20" style="border: 1px solid gray;">
						<!-- <el-input v-model="firstform.content" type="textarea" :rows="8"></el-input> -->
						<tinymce-editor v-model="firstform.content" :init="initEditor" />
					</el-col>
				</el-form-item>

				<el-form-item label="内容(英文)" prop="content">
					<el-col :span="20" style="border: 1px solid gray;">
						<!-- <el-input v-model="firstform.content1" type="textarea" :rows="8"></el-input> -->
						<tinymce-editor v-model="firstform.content1" :init="initEditor" />
					</el-col>
				</el-form-item>

				<el-form-item label="首页背景图片" prop="title" label-width="200px;">
					<el-col :span="15">
						<el-upload class="avatar-uploader" :action="uploadUrl" :show-file-list="false"
							:on-success="handleAvatarSuccess11" :before-upload="beforeAvatarUpload">
							<img v-if="firstform.bg" :src="firstform.bg" class="avatar">
							<i v-else class="el-icon-plus avatar-uploader-icon"></i>
						</el-upload>
					</el-col>
				</el-form-item>


			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="firstDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="save(1)">{{ btnText }}</el-button>
			</span>
		</el-dialog>

		<el-dialog title="修改信息" :visible.sync="secondDialogVisible" width="60%" center>
			<el-form ref="form" :model="secondform" label-width="80px">

				<div v-for="(item,index) in secondTitle" :key="index">
					<el-form-item :label="item.title" prop="title" label-width="200px;" v-if="item.contentType == 1">
						<el-col :span="15" style="border: 1px solid gray;">
							<!-- <el-input v-model="secondTitle[index].content"></el-input> -->
							<tinymce-editor v-model="secondTitle[index].content" :init="initEditor" />
						</el-col>
					</el-form-item>

				</div>

				<el-form-item :label="secondTitle[24].title" prop="title" label-width="200px;">
					<el-col :span="15">
						<el-upload class="avatar-uploader" :action="uploadUrl" :show-file-list="false"
							:on-success="handleAvatarSuccess1" :before-upload="beforeAvatarUpload">
							<img v-if="secondTitle[24].content" :src="secondTitle[24].content" class="avatar">
							<i v-else class="el-icon-plus avatar-uploader-icon"></i>
						</el-upload>
					</el-col>
				</el-form-item>

				<el-form-item :label="secondTitle[25].title" prop="title" label-width="200px;">
					<el-col :span="15">
						<el-upload class="avatar-uploader" :action="uploadUrl" :show-file-list="false"
							:on-success="handleAvatarSuccess2" :before-upload="beforeAvatarUpload">
							<img v-if="secondTitle[25].content" :src="secondTitle[25].content" class="avatar">
							<i v-else class="el-icon-plus avatar-uploader-icon"></i>
						</el-upload>
					</el-col>
				</el-form-item>

				<el-form-item :label="secondTitle[28].title" prop="title" label-width="200px;">
					<el-col :span="15">
						<el-upload class="avatar-uploader" :action="uploadUrl" :show-file-list="false"
							:on-success="handleAvatarSuccess3" :before-upload="beforeAvatarUpload">
							<img v-if="secondTitle[28].content" :src="secondTitle[28].content" class="avatar">
							<i v-else class="el-icon-plus avatar-uploader-icon"></i>
						</el-upload>
					</el-col>
				</el-form-item>

				<el-form-item :label="secondTitle[29].title" prop="title" label-width="200px;">
					<el-col :span="15">
						<el-upload class="avatar-uploader" :action="uploadUrl" :show-file-list="false"
							:on-success="handleAvatarSuccess4" :before-upload="beforeAvatarUpload">
							<img v-if="secondTitle[29].content" :src="secondTitle[29].content" class="avatar">
							<i v-else class="el-icon-plus avatar-uploader-icon"></i>
						</el-upload>
					</el-col>
				</el-form-item>

				<el-form-item :label="secondTitle[32].title" prop="title" label-width="200px;">
					<el-col :span="15">
						<el-upload class="avatar-uploader" :action="uploadUrl" :show-file-list="false"
							:on-success="handleAvatarSuccess5" :before-upload="beforeAvatarUpload">
							<img v-if="secondTitle[32].content" :src="secondTitle[32].content" class="avatar">
							<i v-else class="el-icon-plus avatar-uploader-icon"></i>
						</el-upload>
					</el-col>
				</el-form-item>

				<el-form-item :label="secondTitle[33].title" prop="title" label-width="200px;">
					<el-col :span="15">
						<el-upload class="avatar-uploader" :action="uploadUrl" :show-file-list="false"
							:on-success="handleAvatarSuccess6" :before-upload="beforeAvatarUpload">
							<img v-if="secondTitle[33].content" :src="secondTitle[33].content" class="avatar">
							<i v-else class="el-icon-plus avatar-uploader-icon"></i>
						</el-upload>
					</el-col>
				</el-form-item>

				<el-form-item :label="secondTitle[36].title" prop="title" label-width="200px;">
					<el-col :span="15">
						<el-upload class="avatar-uploader" :action="uploadUrl" :show-file-list="false"
							:on-success="handleAvatarSuccess7" :before-upload="beforeAvatarUpload">
							<img v-if="secondTitle[36].content" :src="secondTitle[36].content" class="avatar">
							<i v-else class="el-icon-plus avatar-uploader-icon"></i>
						</el-upload>
					</el-col>
				</el-form-item>

				<el-form-item :label="secondTitle[37].title" prop="title" label-width="200px;">
					<el-col :span="15">
						<el-upload class="avatar-uploader" :action="uploadUrl" :show-file-list="false"
							:on-success="handleAvatarSuccess8" :before-upload="beforeAvatarUpload">
							<img v-if="secondTitle[37].content" :src="secondTitle[37].content" class="avatar">
							<i v-else class="el-icon-plus avatar-uploader-icon"></i>
						</el-upload>
					</el-col>
				</el-form-item>

			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="secondDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="save(2)">{{ btnText }}</el-button>
			</span>
		</el-dialog>

		<el-dialog title="修改信息" :visible.sync="fourthDialogVisible" width="60%" center>
			<el-form ref="form" :model="fourthform" label-width="80px">

				<el-form-item label="标题(中文)" prop="title">
					<el-col :span="20" style="border: 1px solid gray;">
						<!-- <el-input v-model="fourthform.title"></el-input> -->
						<tinymce-editor v-model="fourthform.title" :init="initEditor" />
					</el-col>
				</el-form-item>

				<el-form-item label="标题(英文)" prop="title">
					<el-col :span="20" style="border: 1px solid gray;">
						<!-- <el-input v-model="fourthform.title1"></el-input> -->
						<tinymce-editor v-model="fourthform.title1" :init="initEditor" />
					</el-col>
				</el-form-item>

				<el-form-item label="内容(中文)" prop="title">
					<el-col :span="20" style="border: 1px solid gray;">
						<!-- <el-input v-model="fourthform.content"></el-input> -->
						<tinymce-editor v-model="fourthform.content" :init="initEditor" />
					</el-col>
				</el-form-item>

				<el-form-item label="内容(英文)" prop="title">
					<el-col :span="20" style="border: 1px solid gray;">
						<!-- <el-input v-model="fourthform.content1"></el-input> -->
						<tinymce-editor v-model="fourthform.content1" :init="initEditor" />
					</el-col>
				</el-form-item>


				<el-form-item label="按钮(中文)" prop="title">
					<el-col :span="20" style="border: 1px solid gray;">
						<!-- <el-input v-model="fourthform.btn"></el-input> -->
						<tinymce-editor v-model="fourthform.btn" :init="initEditor" />
					</el-col>
				</el-form-item>

				<el-form-item label="按钮(英文)" prop="title">
					<el-col :span="20" style="border: 1px solid gray;">
						<!-- <el-input v-model="fourthform.btn1"></el-input> -->
						<tinymce-editor v-model="fourthform.btn1" :init="initEditor" />
					</el-col>
				</el-form-item>


			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="fourthDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="save(4)">{{ btnText }}</el-button>
			</span>
		</el-dialog>

		<el-dialog title="修改信息" :visible.sync="fifthDialogVisible" width="60%" center>
			<el-form ref="form" :model="secondform" label-width="80px">

				<div v-for="(item,index) in fifthTitle" :key="index">
					<el-form-item :label="item.title" prop="title" label-width="200px;" v-if="item.contentType == 1">
						<el-col :span="15" style="border: 1px solid gray;">
							<!-- <el-input v-model="fifthTitle[index].content"></el-input> -->
							<tinymce-editor v-model="fifthTitle[index].content" :init="initEditor" />
						</el-col>
					</el-form-item>

				</div>

			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="fifthDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="save(5)">{{ btnText }}</el-button>
			</span>
		</el-dialog>

		<el-dialog title="修改信息" :visible.sync="sixthDialogVisible" width="60%" center>
			<el-form ref="form" :model="sixthform" label-width="80px">

				<div v-for="(item,index) in sixthTitle" :key="index">
					<el-form-item :label="item.title" prop="title" label-width="200px;" v-if="item.contentType == 1">
						<el-col :span="15" style="border: 1px solid gray;">
							<!-- <el-input v-model="sixthTitle[index].content"></el-input> -->
							<tinymce-editor v-model="sixthTitle[index].content" :init="initEditor" />
						</el-col>
					</el-form-item>

				</div>

			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="sixthDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="save(6)">{{ btnText }}</el-button>
			</span>
		</el-dialog>

		<el-dialog title="修改信息" :visible.sync="seventhDialogVisible" width="60%" center>
			<el-form ref="form" :model="seventhform" label-width="80px">

				<div v-for="(item,index) in seventhTitle" :key="index">
					<el-form-item :label="item.title" prop="title" label-width="200px;" v-if="item.contentType == 1">
						<el-col :span="15" style="border: 1px solid gray;">
							<!-- <el-input v-model="seventhTitle[index].content"></el-input> -->
							<tinymce-editor v-model="seventhTitle[index].content" :init="initEditor" />
						</el-col>
					</el-form-item>

				</div>

			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="seventhDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="save(7)">{{ btnText }}</el-button>
			</span>
		</el-dialog>

		<el-dialog title="修改信息" :visible.sync="eightDialogVisible" width="60%" center>
			<el-form ref="form" :model="eightform" label-width="80px">

				<div v-for="(item,index) in eightTitle" :key="index">
					<el-form-item :label="item.title" prop="title" label-width="200px;" v-if="item.contentType == 1">
						<el-col :span="15" style="border: 1px solid gray;">
							<!-- <el-input v-model="eightTitle[index].content"></el-input> -->
							<tinymce-editor v-model="eightTitle[index].content" :init="initEditor" />
						</el-col>
					</el-form-item>

				</div>

			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="eightDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="save(8)">{{ btnText }}</el-button>
			</span>
		</el-dialog>

		<el-dialog title="修改信息" :visible.sync="ninethDialogVisible" width="60%" center>
			<el-form ref="form" :model="ninethform" label-width="80px">

				<div v-for="(item,index) in ninethTitle" :key="index">
					<el-form-item :label="item.title" prop="title" label-width="200px;" v-if="item.contentType == 1">
						<el-col :span="15" style="border: 1px solid gray;">
							<!-- <el-input v-model="ninethTitle[index].content"></el-input> -->
							<tinymce-editor v-model="ninethTitle[index].content" :init="initEditor" />
						</el-col>
					</el-form-item>

				</div>

			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="ninethDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="save(9)">{{ btnText }}</el-button>
			</span>
		</el-dialog>

	</div>
</template>

<script>
	import TinymceEditor from '../../components/TinymceEditor/index.vue';
	export default {
		name: "Home",
		components: {
			TinymceEditor
		},
		data() {
			return {
				cirleDialogVisible:false,
				dialogImageUrl: '',
				dialogVisible: false,
				imageList: [],
				imageList1: [],
				cirleform: {
					title: "",
					content: "",
					bg: ""
				},
				uploadUrl: "https://zyjwsys.sxsla.cn/files/upload",
				user: JSON.parse(sessionStorage.getItem('CurUser')),
				rowCenter: {
					"text-align": "center"
				},
				firstDialogVisible: false,
				firstData: [],
				firstform: {
					title: "",
					content: "",
					bg: ""
				},
				secondDialogVisible: false,
				secondTitle: [{
						"title": "左上角标题(中文)",
						"content": "",
						"contentType": 1
					}, {
						"title": "左上角标题(英文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "左边标题(中文)",
						"content": "",
						"contentType": 1
					}, {
						"title": "左边标题(英文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "左边第一块标题(中文)",
						"content": "",
						"contentType": 1
					}, {
						"title": "左边第一块标题(英文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "左边第一块数字(中文)",
						"content": "",
						"contentType": 1
					}, {
						"title": "左边第一块数字(英文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "左边第一块内容(中文)",
						"content": "",
						"contentType": 1
					}, {
						"title": "左边第一块内容(英文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "左边第二块标题(中文)",
						"content": "",
						"contentType": 1
					}, {
						"title": "左边第二块标题(英文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "左边第二块数字(中文)",
						"content": "",
						"contentType": 1
					}, {
						"title": "左边第二块数字(英文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "左边第二块内容(中文)",
						"content": "",
						"contentType": 1
					}, {
						"title": "左边第二块内容(英文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "左边第三块标题(中文)",
						"content": "",
						"contentType": 1
					}, {
						"title": "左边第三块标题(英文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "左边第三块数字(中文)",
						"content": "",
						"contentType": 1
					}, {
						"title": "左边第三块数字(英文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "左边第三块内容(中文)",
						"content": "",
						"contentType": 1
					}, {
						"title": "左边第三块内容(英文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "案例第一块内容(中文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "案例第一块内容(英文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "案例第一块logo(中文)",
						"content": "",
						"contentType": 2
					},
					{
						"title": "案例第一块logo(英文)",
						"content": "",
						"contentType": 2
					},
					{
						"title": "案例第二块内容(中文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "案例第二块内容(中文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "案例第二块logo(中文)",
						"content": "",
						"contentType": 2
					},
					{
						"title": "案例第二块logo(英文)",
						"content": "",
						"contentType": 2
					},
					{
						"title": "案例第三块内容(中文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "案例第三块内容(英文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "案例第三块logo(中文)",
						"content": "",
						"contentType": 2
					}, {
						"title": "案例第三块logo(英文)",
						"content": "",
						"contentType": 2
					},
					{
						"title": "案例第四块内容(中文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "案例第四块内容(英文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "案例第四块logo(中文)",
						"content": "",
						"contentType": 2
					}, {
						"title": "案例第四块logo(英文)",
						"content": "",
						"contentType": 2
					}
				],
				secondform: {

				},
				secondImageUrl: ["https://xlhzfile.sxsla.cn/files/2z1e0igo.png"],
				secondData: [],
				thirdDialogVisible: false,
				thirdData: [{
					"content": "",
					"contentEg": ""
				}],
				thirdform: {
					title: "",
					content: "",
				},
				fourthDialogVisible: false,
				fourthData: [{
					"content": "",
					"contentEg": ""
				}, {
					"content": "",
					"contentEg": ""
				}, {
					"content": "",
					"contentEg": ""
				}],
				fourthform: {
					title: "",
					content: "",
					btn: ""
				},
				fifthDialogVisible: false,
				fifthTitle: [{
						"title": "左上角标题(中文)",
						"content": "",
						"contentType": 1
					}, {
						"title": "左上角标题(英文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "左边标题(中文)",
						"content": "",
						"contentType": 1
					}, {
						"title": "左边标题(英文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "右边第一块标题(中文)",
						"content": "",
						"contentType": 1
					}, {
						"title": "右边第一块标题(英文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "右边第一块内容(中文)",
						"content": "",
						"contentType": 1
					}, {
						"title": "右边第一块内容(英文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "右边第二块标题(中文)",
						"content": "",
						"contentType": 1
					}, {
						"title": "右边第二块标题(英文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "右边第二块内容(中文)",
						"content": "",
						"contentType": 1
					}, {
						"title": "右边第二块内容(英文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "右边第三块标题(中文)",
						"content": "",
						"contentType": 1
					}, {
						"title": "右边第三块标题(英文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "右边第三块内容(中文)",
						"content": "",
						"contentType": 1
					}, {
						"title": "右边第三块内容(英文)",
						"content": "",
						"contentType": 1
					}
				],
				fifthform: {

				},
				fifthData: [],
				sixthDialogVisible: false,
				sixthTitle: [{
						"title": "标题(中文)",
						"content": "",
						"contentType": 1
					}, {
						"title": "标题(英文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "内容(中文)",
						"content": "",
						"contentType": 1
					}, {
						"title": "内容(英文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "第一块小标题(中文)",
						"content": "",
						"contentType": 1
					}, {
						"title": "第一块小标题(英文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "第一块大标题(中文)",
						"content": "",
						"contentType": 1
					}, {
						"title": "第一块大标题(英文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "第一块内容(中文)",
						"content": "",
						"contentType": 1
					}, {
						"title": "第一块内容(英文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "第二块小标题(中文)",
						"content": "",
						"contentType": 1
					}, {
						"title": "第二块小标题(英文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "第二块大标题(中文)",
						"content": "",
						"contentType": 1
					}, {
						"title": "第二块大标题(英文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "第二块内容(中文)",
						"content": "",
						"contentType": 1
					}, {
						"title": "第二块内容(英文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "第三块小标题(中文)",
						"content": "",
						"contentType": 1
					}, {
						"title": "第三块小标题(英文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "第三块大标题(中文)",
						"content": "",
						"contentType": 1
					}, {
						"title": "第三块大标题(英文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "第三块内容(中文)",
						"content": "",
						"contentType": 1
					}, {
						"title": "第三块内容(英文)",
						"content": "",
						"contentType": 1
					}
				],
				sixthform: {

				},
				sixthData: [],
				seventhDialogVisible: false,
				seventhTitle: [{
						"title": "标题(中文)",
						"content": "",
						"contentType": 1
					}, {
						"title": "标题(英文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "内容(中文)",
						"content": "",
						"contentType": 1
					}, {
						"title": "内容(英文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "按钮(中文)",
						"content": "",
						"contentType": 1
					}, {
						"title": "按钮(英文)",
						"content": "",
						"contentType": 1
					}
				],
				seventhform: {

				},
				seventhData: [],
				eightDialogVisible: false,
				eightTitle: [{
						"title": "标题(中文)",
						"content": "",
						"contentType": 1
					}, {
						"title": "标题(英文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "内容(中文)",
						"content": "",
						"contentType": 1
					}, {
						"title": "内容(英文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "按钮(中文)",
						"content": "",
						"contentType": 1
					}, {
						"title": "按钮(英文)",
						"content": "",
						"contentType": 1
					}
				],
				eightform: {

				},
				eightData: [],
				ninethDialogVisible: false,
				ninethTitle: [{
						"title": "内容(中文)",
						"content": "",
						"contentType": 1
					}, {
						"title": "内容(英文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "按钮(中文)",
						"content": "",
						"contentType": 1
					}, {
						"title": "按钮(英文)",
						"content": "",
						"contentType": 1
					}
				],
				ninethform: {

				},
				ninethData: [],
				btnText: "提 交",
			}
		},
		beforeMount() {
			this.secondData = [];

			for (var i = 0; i < this.secondTitle.length; i++) {
				if (i % 2 != 0) {
					var bean = {
						id: "",
						title: "first_page_second_title" + (i + 1),
						content: "",
						contentType: this.secondTitle[i].contentType,
						contentEg: "",
						type: "first_page_second"
					}
					this.secondData.push(bean);
				}
				this.$set(this.secondform, 'title' + (i + 1), '');
			}

			for (var i = 0; i < this.fifthTitle.length; i++) {
				if (i % 2 != 0) {
					var bean = {
						id: "",
						title: "first_page_fifth_title" + (i + 1),
						content: "",
						contentType: this.fifthTitle[i].contentType,
						contentEg: "",
						type: "first_page_fifth"
					}
					this.fifthData.push(bean);
				}
				this.$set(this.fifthform, 'title' + (i + 1), '');
			}

			for (var i = 0; i < this.sixthTitle.length; i++) {
				if (i % 2 != 0) {
					var bean = {
						id: "",
						title: "first_page_sixth_title" + (i + 1),
						content: "",
						contentType: this.sixthTitle[i].contentType,
						contentEg: "",
						type: "first_page_sixth"
					}
					this.sixthData.push(bean);
				}
				this.$set(this.sixthform, 'title' + (i + 1), '');
			}

			for (var i = 0; i < this.seventhTitle.length; i++) {
				if (i % 2 != 0) {
					var bean = {
						id: "",
						title: "first_page_seventh_title" + (i + 1),
						content: "",
						contentType: this.seventhTitle[i].contentType,
						contentEg: "",
						type: "first_page_seventh"
					}
					this.seventhData.push(bean);
				}
				this.$set(this.seventhform, 'title' + (i + 1), '');
			}

			for (var i = 0; i < this.eightTitle.length; i++) {
				if (i % 2 != 0) {
					var bean = {
						id: "",
						title: "first_page_eight_title" + (i + 1),
						content: "",
						contentType: this.eightTitle[i].contentType,
						contentEg: "",
						type: "first_page_eight"
					}
					this.eightData.push(bean);
				}
				this.$set(this.eightform, 'title' + (i + 1), '');
			}

			for (var i = 0; i < this.ninethTitle.length; i++) {
				if (i % 2 != 0) {
					var bean = {
						id: "",
						title: "first_page_nineth_title" + (i + 1),
						content: "",
						contentType: this.ninethTitle[i].contentType,
						contentEg: "",
						type: "first_page_nineth"
					}
					this.ninethData.push(bean);
				}
				this.$set(this.ninethform, 'title' + (i + 1), '');
			}

			// console.log("11--" + JSON.stringify(this.secondData));
			this.getData();
		},
		computed: {
			// 初始化富文本
			initEditor() {
				return {
					height: 300,
					branding: false,
					skin_url: '/tinymce/skins/ui/oxide',
					content_css: '/tinymce/skins/content/default/content.css',
					language_url: '/tinymce/langs/zh_CN.js',
					language: 'zh_CN',
					plugins: 'code print preview fullscreen paste searchreplace save autosave link autolink image imagetools media table codesample lists advlist hr charmap emoticons anchor directionality pagebreak quickbars nonbreaking visualblocks visualchars wordcount',
					toolbar: 'fullscreen preview code | undo redo | forecolor backcolor | bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | outdent indent | numlist bullist | formatselect fontselect fontsizeselect | link image media emoticons charmap anchor pagebreak codesample | ltr rtl',
					toolbar_drawer: 'sliding',
					fontsize_formats: '8px 10px 12px 14px 18px 24px 36px 48px 60px 72px 80px 90px 100px 110px 120px 140px 180px',
					images_upload_handler: (blobInfo, success, error) => {
						let file = blobInfo.blob();
						// 使用axios上传
						const formData = new FormData();
						formData.append('file', file, file.name);
						this.$http.post('https://zyjwsys.sxsla.cn/files/upload', formData).then(res => {
							if (res.data.code == 0) {
								success(res.data.data);
							} else {
								error(res.data.msg);
							}
						}).catch(e => {
							console.error(e);
							error(e.message);
						});
					},
					file_picker_types: 'media',
					file_picker_callback: () => {}
				}
			}
		},

		methods: {
			handleRemove22(file, fileList) {
				this.imageList = this.imageList.filter(item => !item.includes(file.name));
				// console.log("2222---", JSON.stringify(this.imageList));
			},
			handlePictureCardPreview22(file) {
				this.dialogImageUrl = file.url;
				this.dialogVisible = true;
			},
			handleAvatarSuccess22(res, file, item) {

				this.imageList.push("https://image.sxsla.cn/files/" + res.data.name);
			},
			beforeAvatarUpload22(file) {
				const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
				const isLt2M = file.size / 1024 / 1024 < 2;

				// if (!isJPG) {
				// 	this.$message.error('上传头像图片只能是 JPG 格式!');
				// }
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 2MB!');
				}

				return isJPG && isLt2M;
			},
			save(type) {
				var that = this;
				if (type == 1) {
					var params = [{
						id: this.firstData[0].id,
						title: "title",
						content: this.firstform.title,
						contentEg: this.firstform.title1,
						type: "first_page_first"
					}, {
						id: this.firstData[1].id,
						title: "content",
						content: this.firstform.content,
						contentEg: this.firstform.content1,
						type: "first_page_first"
					}, {
						id: this.firstData[2].id,
						title: "bg",
						content: this.firstform.bg,
						type: "first_page_first"
					}];
					this.utils.requestPost(this, "/content/add", params, function(res, total) {
						that.utils.showMessage("success", "保存成功");
						that.firstDialogVisible = false;
						that.getData();
					});
				} else if (type == 2) {
					for (var i = 0; i < this.secondData.length; i++) {
						var bean = this.secondData[i];
						var j = i * 2;
						bean.content = this.secondTitle[j].content;
						bean.contentEg = this.secondTitle[j + 1].content;
						bean.id = this.secondTitle[j].id;
					}
					// console.log("22---" + JSON.stringify(this.secondData))
					this.utils.requestPost(this, "/content/add", this.secondData, function(res, total) {
						that.utils.showMessage("success", "保存成功");
						that.secondDialogVisible = false;
						that.getData();
					});
				} else if (type == 3) {
					var params = [{
						id: this.thirdData[0].id,
						title: "title",
						content: this.thirdform.title,
						contentEg: this.thirdform.title1,
						type: "first_page_third"
					}];

					this.utils.requestPost(this, "/content/add", params, function(res, total) {
						that.utils.showMessage("success", "保存成功");
						that.thirdDialogVisible = false;
						that.getData();
					});
				} else if (type == 4) {
					var params = [{
						id: this.fourthData[0].id,
						title: "title",
						content: this.fourthform.title,
						contentEg: this.fourthform.title1,
						type: "first_page_fourth"
					}, {
						id: this.fourthData[1].id,
						title: "content",
						content: this.fourthform.content,
						contentEg: this.fourthform.content1,
						type: "first_page_fourth"
					}, {
						id: this.fourthData[2].id,
						title: "btn",
						content: this.fourthform.btn,
						contentEg: this.fourthform.btn1,
						type: "first_page_fourth"
					}];
					// console.log("22---" + JSON.stringify(params))
					this.utils.requestPost(this, "/content/add", params, function(res, total) {
						that.utils.showMessage("success", "保存成功");
						that.fourthDialogVisible = false;
						that.getData();
					});
				} else if (type == 5) {
					for (var i = 0; i < this.fifthData.length; i++) {
						var bean = this.fifthData[i];
						var j = i * 2;
						bean.content = this.fifthTitle[j].content;
						bean.contentEg = this.fifthTitle[j + 1].content;
						bean.id = this.fifthTitle[j].id;
					}
					// console.log("22---" + JSON.stringify(this.secondData))
					this.utils.requestPost(this, "/content/add", this.fifthData, function(res, total) {
						that.utils.showMessage("success", "保存成功");
						that.fifthDialogVisible = false;
						that.getData();
					});
				} else if (type == 6) {
					for (var i = 0; i < this.sixthData.length; i++) {
						var bean = this.sixthData[i];
						var j = i * 2;
						bean.content = this.sixthTitle[j].content;
						bean.contentEg = this.sixthTitle[j + 1].content;
						bean.id = this.sixthTitle[j].id;
					}
					// console.log("22---" + JSON.stringify(this.sixthData))
					this.utils.requestPost(this, "/content/add", this.sixthData, function(res, total) {
						that.utils.showMessage("success", "保存成功");
						that.sixthDialogVisible = false;
						that.getData();
					});
				} else if (type == 7) {
					for (var i = 0; i < this.seventhData.length; i++) {
						var bean = this.seventhData[i];
						var j = i * 2;
						bean.content = this.seventhTitle[j].content;
						bean.contentEg = this.seventhTitle[j + 1].content;
						bean.id = this.seventhTitle[j].id;
					}
					// console.log("22---" + JSON.stringify(this.sixthData))
					this.utils.requestPost(this, "/content/add", this.seventhData, function(res, total) {
						that.utils.showMessage("success", "保存成功");
						that.seventhDialogVisible = false;
						that.getData();
					});
				} else if (type == 8) {
					for (var i = 0; i < this.eightData.length; i++) {
						var bean = this.eightData[i];
						var j = i * 2;
						bean.content = this.eightTitle[j].content;
						bean.contentEg = this.eightTitle[j + 1].content;
						bean.id = this.eightTitle[j].id;
					}
					// console.log("22---" + JSON.stringify(this.sixthData))
					this.utils.requestPost(this, "/content/add", this.eightData, function(res, total) {
						that.utils.showMessage("success", "保存成功");
						that.eightDialogVisible = false;
						that.getData();
					});
				} else if (type == 9) {
					for (var i = 0; i < this.ninethData.length; i++) {
						var bean = this.ninethData[i];
						var j = i * 2;
						bean.content = this.ninethTitle[j].content;
						bean.contentEg = this.ninethTitle[j + 1].content;
						bean.id = this.ninethTitle[j].id;
					}
					// console.log("22---" + JSON.stringify(this.sixthData))
					this.utils.requestPost(this, "/content/add", this.ninethData, function(res, total) {
						that.utils.showMessage("success", "保存成功");
						that.ninethDialogVisible = false;
						that.getData();
					});
				} else if (type == 10) {
					var params = [{
						id: 307,
						title: "sycirle",
						content: this.imageList.join(","),
						contentEg: "",
						type: "first_page_first"
					}];
					this.utils.requestPost(this, "/content/add", params, function(res, total) {
						that.utils.showMessage("success", "保存成功");
						that.cirleDialogVisible = false;
						that.getData();
					});
				}




			},
			eidt(type) {
				if (type == 1) {
					this.firstDialogVisible = true;
				} else if (type == 2) {
					this.secondDialogVisible = true;
				} else if (type == 3) {
					this.thirdDialogVisible = true;
				} else if (type == 4) {
					this.fourthDialogVisible = true;
				} else if (type == 5) {
					this.fifthDialogVisible = true;
				} else if (type == 6) {
					this.sixthDialogVisible = true;
				} else if (type == 7) {
					this.seventhDialogVisible = true;
				} else if (type == 8) {
					this.eightDialogVisible = true;
				} else if (type == 9) {
					this.ninethDialogVisible = true;
				}else if (type == 10) {
					this.cirleDialogVisible = true;
				}
			},
			getData() {
				var that = this;
				var params = {
					"param": {
						'type': 'first_page'
					}
				};
				// this.utils.requestPost(this, "/headerMenu/getMenuDataList", params, function(res, total) {
				this.utils.requestPost(this, "/content/getDataList", params, function(res, total) {
					// console.log("222---" + JSON.stringify(res))
					that.firstData = [];
					that.thirdData = [];
					that.fourthData = [];
					var j = 0;
					var k = 0;
					var m = 0;
					var n = 0;
					var p = 0;
					var x = 0;
						var y = 0;
					for (var i = 0; i < res.length; i++) {
						var bean = res[i];
						if (bean.type == 'first_page_first' && bean.title == 'title') {
							that.firstform.title = bean.content
							that.firstform.title1 = bean.contentEg
							that.firstData.push(bean);
						} else if (bean.type == 'first_page_first' && bean.title == 'content') {
							that.firstform.content = bean.content
							that.firstform.content1 = bean.contentEg
							that.firstData.push(bean);
						} else if (bean.type == 'first_page_first' && bean.title == 'bg') {
							that.firstform.bg = bean.bg;
							that.firstData.push(bean);
						} else if (bean.type == 'first_page_second') {
							that.secondTitle[j].id = bean.id;
							that.secondTitle[j].content = bean.content;
							that.secondTitle[j + 1].id = bean.id;
							that.secondTitle[j + 1].content = bean.contentEg;
							j = j + 2;
						} else if (bean.type == 'first_page_third') {
							that.thirdform.title = bean.content
							that.thirdform.title1 = bean.contentEg
							that.thirdData.push(bean);
						} else if (bean.type == 'first_page_fourth') {
							if (bean.title == 'title') {
								that.fourthform.title = bean.content
								that.fourthform.title1 = bean.contentEg
							} else if (bean.title == 'content') {
								that.fourthform.content = bean.content
								that.fourthform.content1 = bean.contentEg
							} else if (bean.title == 'btn') {
								that.fourthform.btn = bean.content
								that.fourthform.btn1 = bean.contentEg
							}
							that.fourthData.push(bean);
						} else if (bean.type == 'first_page_fifth') {
							that.fifthTitle[k].id = bean.id;
							that.fifthTitle[k].content = bean.content;
							that.fifthTitle[k + 1].id = bean.id;
							that.fifthTitle[k + 1].content = bean.contentEg;
							k = k + 2;
						} else if (bean.type == 'first_page_sixth') {
							that.sixthTitle[m].id = bean.id;
							that.sixthTitle[m].content = bean.content;
							that.sixthTitle[m + 1].id = bean.id;
							that.sixthTitle[m + 1].content = bean.contentEg;
							m = m + 2;
						} else if (bean.type == 'first_page_seventh') {
							that.seventhTitle[n].id = bean.id;
							that.seventhTitle[n].content = bean.content;
							that.seventhTitle[n + 1].id = bean.id;
							that.seventhTitle[n + 1].content = bean.contentEg;
							n = n + 2;
						} else if (bean.type == 'first_page_eight') {
							that.eightTitle[p].id = bean.id;
							that.eightTitle[p].content = bean.content;
							that.eightTitle[p + 1].id = bean.id;
							that.eightTitle[p + 1].content = bean.contentEg;
							p = p + 2;
						} else if (bean.type == 'first_page_nineth') {
							that.ninethTitle[x].id = bean.id;
							that.ninethTitle[x].content = bean.content;
							that.ninethTitle[x + 1].id = bean.id;
							that.ninethTitle[x + 1].content = bean.contentEg;
							x = x + 2;
						}else if (bean.title == 'sycirle') {
							that.imageList = bean.content.split(",");
							that.imageList1 = [];
							for (var j = 0; j < that.imageList.length; j++) {
								var imageBean = that.imageList[j]
								let index = imageBean.indexOf("files/");
								if (index !== -1) {
									let resultStr = imageBean.substring(index, imageBean.length);
									that.imageList1.push({
										name: resultStr,
										url: imageBean
									})
								}
							
							}
						}

					}
				});
			},
			setImage(url) {
				this.secondImageUrl = [];
				this.secondImageUrl.push(url);
			},
			handleAvatarSuccess11(res, file, item) {
				this.firstform.bg = "https://image.sxsla.cn/files/" + res.data.name;;
			},
			handleAvatarSuccess1(res, file, item) {
				this.secondTitle[24].content = "https://image.sxsla.cn/files/" + res.data.name;;
			},
			handleAvatarSuccess2(res, file, item) {
				this.secondTitle[25].content = "https://image.sxsla.cn/files/" + res.data.name;;
			},
			handleAvatarSuccess3(res, file, item) {
				this.secondTitle[28].content = "https://image.sxsla.cn/files/" + res.data.name;;
			},
			handleAvatarSuccess4(res, file, item) {
				this.secondTitle[29].content = "https://image.sxsla.cn/files/" + res.data.name;;
			},
			handleAvatarSuccess5(res, file, item) {
				this.secondTitle[32].content = "https://image.sxsla.cn/files/" + res.data.name;;
			},
			handleAvatarSuccess6(res, file, item) {
				this.secondTitle[33].content = "https://image.sxsla.cn/files/" + res.data.name;;
			},
			handleAvatarSuccess7(res, file, item) {
				this.secondTitle[36].content = "https://image.sxsla.cn/files/" + res.data.name;;
			},
			handleAvatarSuccess8(res, file, item) {
				this.secondTitle[37].content = "https://image.sxsla.cn/files/" + res.data.name;;
			},
			beforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
				const isLt2M = file.size / 1024 / 1024 < 2;

				// if (!isJPG) {
				// 	this.$message.error('上传头像图片只能是 JPG 格式!');
				// }
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 2MB!');
				}

				return isJPG && isLt2M;
			},
		}
	}
</script>

<style scoped>
	.avatar {
		width: 160px;
		height: 160px;
	}
</style>
